var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ButtonLink from '@/Jetstream/ButtonLink';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useForm } from '@inertiajs/react';
import { useState } from 'react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import ClientFormLayout from './ClientFormLayout';
var ThankYou = function (_a) {
    var user = _a.user, clientForm = _a.clientForm, branch = _a.branch, client = _a.client;
    var _b = useState(true), disabled = _b[0], setDisabled = _b[1];
    var form = useForm({});
    var route = useRoute(Ziggy);
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsx("p", { children: "Thank you for completing your information." }), _jsx("p", { children: "We will review your submission and may follow up with further queries" }), user && _jsx("div", __assign({ className: "flex mt-4" }, { children: _jsxs(ButtonLink, __assign({ className: "", href: route('client-public-form', { clientForm: clientForm }) }, { children: [_jsx(ChevronRightIcon, { className: "h-5 w-5 text-white" }), _jsx("span", { children: "Back to form" })] })) }))] }) }));
};
ThankYou.layout = ClientFormLayout;
export default ThankYou;
